import React from "react";
import {  useParams } from "react-router-dom";
//MUI Components
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
//MUI Icon
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { getAge } from "../common/utilities/AgeCalculator";
import useAuth from "../hooks/useAuth";
import { addFavorite, cmToFeetInches, removeFavorite } from "../../services/profile";
import { ReportButton } from "./report/ReportButton";
import Tooltip from '@mui/material/Tooltip';
import PaymentModal from '../common/PaymentModal';
import ProfileImage from './ProfileImage';

export function listToString(list) {
  let finalString = "";
  list?.forEach((element) => {
    finalString = finalString.concat(element + ", ");
  });
  if (finalString.length > 0) finalString = finalString.slice(0, -2);
  return finalString;
}

function formatDate(isoString) {
  const date = new Date(isoString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
const ProfileCard = ({ profile, isNameClickable }) => {
  const {
    getToken,
    addFavouritesToState,
    removeFavouriteFromState,
    favourites,
    isUserPaymentValid,
  } = useAuth();
  // const [isFavorite, setIsFavorite] = React.useState(false);
  const isFavorite = favourites.findIndex((fav) => fav === profile.id) !== -1;
  const [open, setOpen] = React.useState(false);
  const vertical = "bottom";
  const horizontal = "right";
  const [showPaymentModal, setShowPaymentModal] = React.useState(false);

  const addFavouriteApiCall = async (token, userId) => {
    try {
      let response = await addFavorite(token, userId);
      if (response.data?.addFavourite) {
        // setIsFavorite(true);
        setOpen(true);
        addFavouritesToState(userId);
      } else {
        console.error("debug error in adding facorite", response);
      }
    } catch (error) {
      alert("error in adding favorite");
      console.error("debug in adding favorites", error);
    }
  };

  const removeFavouriteApiCall = async (token, userId) => {
    try {
      let response = await removeFavorite(token, userId);
      if (response.data?.removeFavourite) {
        // setIsFavorite(false);
        setOpen(true);
        removeFavouriteFromState(userId);
      } else {
        console.error("debug error in removing facorite", response);
      }
    } catch (error) {
      alert("error in removing favorite");
      console.error("debug in removing favorites", error);
    }
  };

  const handleClick = async () => {
    let auth = getToken();
    if (auth) {
      console.log("debug pdating favorite", isFavorite);
      if (isFavorite) {
        await removeFavouriteApiCall(auth.token, profile.id);
      } else {
        await addFavouriteApiCall(auth.token, profile.id);
      }
    } else {
      console.error(
        "debug update favorite no auth object found, should be logging out now"
      );
    }
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  //snackbar action
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  function capitalizatString(input) {
    return input.charAt(0).toUpperCase() + input.slice(1);
  }
  let { id } = useParams();
  return (
    <div
      style={{
        border: "1px solid rgba(0,0,0,.125)",
        borderRadius: 10,
        margin: "auto",
        backgroundColor: "#FDFAF6",
      }}
      className="p-4 gap-4 w-full flex flex-col lg:flex-row items-center"
    >
      <div className="w-full sm:w-48 h-full sm:h-64 aspect-[3/4]">
        <div className="relative flex justify-center rounded-lg overflow-hidden w-full sm:w-48 h-full sm:h-64 aspect-[3/4]">
          <ProfileImage profile={profile} />
        </div>
      </div>
      <div className="w-full">
        <div className="card-body p-0">
          <h5 className="card-title">
            {isNameClickable ? (
              <a
                href={`/profile/${profile.id}`}
                className="text-xl sm:text-2xl xl:text-3xl no-underline hover:no-underline text-black font-bold"
              >
                {profile.firstName + " " + profile.lastName}
              </a>
            ) : (
              <div>{profile.firstName + " " + profile.lastName}</div>
            )}
          </h5>
          <div className="card-text" style={{ marginTop: 2 }}>
            <div className="container w-full m-0">
              <div className="flex flex-col lg:flex-row justify-between items-start w-full">
                <div className="flex flex-col items-center justify-start w-full">
                  <div className="d-block mb-2 w-full">
                    <span className="font-semibold">AGE: </span>
                    {getAge(profile.dob)}
                  </div>
                  <div className="d-block mb-2 w-full">
                    <span className="font-semibold">LOCATION: </span>
                    {capitalizatString(profile.city)}
                  </div>
                  <div className="d-block mb-2 w-full">
                    <span className="font-semibold">DEGREE: </span>
                    {listToString(profile.qualifications)}
                  </div>
                  <div className="d-block mb-2 w-full">
                    <span className="font-semibold">OCCUPATION: </span>
                    {profile.occupation}
                  </div>
                </div>
                <div className="flex flex-col items-center justify-start w-full">
                  <div className="d-block mb-2 w-full">
                    <span className="font-semibold">DOB: </span>
                    {formatDate(profile.dob)}
                  </div>
                  <div className="d-block mb-2 w-full">
                    <span className="font-semibold">FOOD PREFERENCE: </span>
                    {profile.foodHabits}
                  </div>
                  <div className="d-block mb-2 w-full">
                    <span className="font-semibold">HEIGHT: </span>
                    {cmToFeetInches(profile.height)} tall
                  </div>
                  <div className="d-block mb-2 w-full">
                    <span className="font-semibold">WEIGHT: </span>
                    {profile.weight} kgs
                  </div>
                </div>
              </div>
              <div className="row" style={{ marginTop: 10 }}>
                <div className="flex flex-col md:flex-row justify-start items-center gap-2">
                  {isUserPaymentValid ? (
                    <div className="btn btn-ghost" onClick={() => {handleClick()}}>
                      {isFavorite ? (
                        <FavoriteIcon
                          style={{ color: "red" }}/>
                      ) : (
                        <FavoriteBorderIcon />
                      )}
                    </div>
                  ) : (
                    <Tooltip title="Unlock favourites feature with annual subscription">
                      <div className="btn btn-ghost" onClick={() => setShowPaymentModal(true)} style={{ cursor: 'pointer' }}>
                        {isFavorite ? (
                          <FavoriteIcon style={{ color: "#ccc" }} disabled />
                        ) : (
                          <FavoriteBorderIcon style={{ color: "#ccc" }} disabled />
                        )}
                      </div>
                    </Tooltip>
                  )}
                  {id ? null : (
                    <a href={`/profile/${profile.id}`} className="w-full sm:w-fit">
                      <button className="btn btn-primary leading-none w-full">
                        View More
                      </button>
                    </a>
                  )}
                  <ReportButton profileId={profile.id} />

                  <Snackbar
                    anchorOrigin={{
                      vertical,
                      horizontal,
                    }}
                    open={open}
                    autoHideDuration={2000}
                    onClose={handleClose}
                    message={
                      isFavorite
                        ? "Added to favorites"
                        : "Removed from favorites"
                    }
                    action={action}
                    key={vertical + horizontal}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PaymentModal open={showPaymentModal} onClose={() => setShowPaymentModal(false)} />
    </div>
  );
};

export default ProfileCard;
